// import React from 'react'
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
// import ValidationText from './ValidationText';

const Divider = ({ item, setItem, activeAccordion, dragHandleProps }) => {
  // const { handleSetDivider } = useNewItemChange(setItem, 'Viewer', activeAccordion);


  return (
    <>
      <div className=''>
        <div className='w-100 ar-intake-divider'></div>
      </div>
    </>
  );
};

export default Divider